import React, { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';

interface Props {
  options: {
    label: ReactNode;
    value: ReactNode;
  }[];
}

export const OptionsList = ({ options }: Props) => {
  return (
    <Stack direction="row" gap="1rem" flexWrap="wrap">
      {options.map(({ value, label }, index) => {
        return (
          <Stack key={index}>
            <Typography variant="subtitle1" component="span">
              {label}
            </Typography>

            <Typography variant="subtitle2" component="span" color="textDisabled">
              {value}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};
